module.exports = __webpack_public_path__ + "img/u11.a363f58e.png";